<template>
    <div>
        <b-modal v-model="shown" size="lg">
            <template #modal-header>
                <b-row>
                    <b-col align-self="end">{{ currentSlide }} / {{ intros }}</b-col>
                </b-row>
            </template>

            <div v-if="viewMore">
                <h5>{{ $t('hereYouCanFindListOfOtherTutorials') }}</h5>

                <ul class="mt-4">
                    <li v-for="more in seeMore" :key="seeMore[more]" @click="startSeeMore(more)" class="seeMoreLink"> {{ $t(`tutorials.seeMore.${more}`) }} <b-icon icon="check" v-if="isDone(more)" style="color:green"/></li>
                </ul>
            </div>

            <div v-else>
                <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="0"
                    img-width="1024"
                    img-height="480"
                    ref="myCarousel"
                >

                    <!-- Slides with img slot -->
                    <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
                    <b-carousel-slide v-for="(slide, idx) in slides" :key="idx">
                        <template #img>
                        <img
                            class="d-block img-fluid w-100"
                            width="1024"
                            height="480"
                            :src="slide.img"
                            v-if="slide.img"
                        >
                        </template>
                    </b-carousel-slide>
                </b-carousel>

                <p class="p-2" v-html="displayText"></p>
            </div>

            <template #modal-footer >
                <template v-if="!viewMore">
                    <b-button variant="warning" @click="dontShow" size="sm" v-if="!isDone('dontshow')"> {{ $t('dontShowTutorials') }} </b-button>

                    <b-button variant="success" @click="viewMore = true" size="sm"> {{ $t('seeMore') }} </b-button>

                    <b-button @click="skip" v-if="!canClose" size="sm">{{ $t('skip') }}</b-button>

                    <b-button @click="prev" variant="primary" v-if="canPrev" size="sm">{{ $t('previous') }}</b-button>

                    <b-button @click="skip" variant="success" v-if="canClose" size="sm">{{ $t('close') }}</b-button>
                    <b-button @click="next" variant="success" v-else size="sm"> {{ $t('next') }} </b-button>

                </template>

                <div v-else>
                    <b-button @click="viewMore = false" variant="success" size="sm">{{ $t('back') }}</b-button>
                </div>
             </template>
        </b-modal>
    </div>
</template>

<script>
import { seeMore } from './tutorials'

export default {
    data: function() {
        return {
            slide: 0,
            done: {},
            seeMore: seeMore,
            overrideName: null
        }
    },

    computed: {
        displayText() {
            const { text = '' } = this.slides[this.slide] || {}
            return this.$t(text)
        },

        intros() {
            return this.slides.length
        },

        currentSlide() {
            return this.slide + 1
        },

        slides() {
            return this.$store.getters.getCurrentTutorial || {}
        },

        canClose() {
            return this.currentSlide == this.intros
        },

        canPrev() {
            return this.intros > 1
        },

        tutorialName: {
            get() {
                if (this.overrideName) return this.overrideName

                return this.name
            },

            set(val) {
                this.overrideName = val
            }
        },

        shown: {
            get() { return this.$store.getters.getShowTutorial },
            set(val) {
                if (val) this.$store.commit("OPEN_TUTORIAL")
                if (!val) this.$store.commit("CLOSE_TUTORIAL")
            }
        },
        
        viewMore: { 
            get() {
                return this.$store.getters.getViewMoreTutorials
            },

            set(val) {
                this.$store.commit("SET_VIEW_MORE_TUTORIALS", val)
            }
        }
    },

    methods: {
        next() {
            this.$refs.myCarousel.next()
        },

        prev() {
            this.$refs.myCarousel.prev()
        },

        skip() {
            this.$store.dispatch('tutorialSkipped')
        },

        startSeeMore(more) {
            this.$store.commit('START_TUTORIAL', more)
            this.viewMore = false
            this.slide = 0
        },

        dontShow() {
            this.$store.dispatch('dontShowTutorials')
        },

        isDone(tut) {
            return this.$store.getters.getDoneTutorials[tut]
        }
    }
}
</script>

<style scoped lang="scss">
.seeMoreLink {
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
}
</style>